import { setupForDark } from '@theme';
import classNames from 'classnames';

function HorizontalLine({ className = '' }: { className?: string }) {
  return (
    <div
      className={classNames('border-t-[1px]', setupForDark('border-secondary'), className)}
    ></div>
  );
}

export default HorizontalLine;
